import { Injectable } from "@angular/core"
import { HttpClient } from '@angular/common/http'
import { DashData } from './dash.model'
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { EnvService } from '../env.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { timeout } from 'rxjs/operators';
import * as moment from 'moment';



@Injectable({ providedIn: 'root' })
export class DashService {
  custInfo: any;
  statesData: any;

  constructor(private http: HttpClient, private router: Router, private env: EnvService) { }

  accountAnalytics = {}
  engagementData = {}
  customersData = {}
  params
  dashInfo
  summaryData; //*
  customSummaryData; //**

  oneYearHubCount = 0;
  oneYearHubData;

  firmwareData;
  oldHubFirmwareData;
  releasedNodeTypeData;

  graphDataForLastYear = {};

  monthsArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  //map for node type and model
  nodeTypeMap = new Map([
    ['HUB', 'EGHB01M'], ['P_1', 'EGSP01R'], ['P16_1', 'EGSP02R'], ['MS_1', 'EGMS01N'],
    ['PA_1', 'EGPA01N'], ['T_1', 'EGTG01N'], ['SSS_1', 'EGIW01R'], ['SSD_1', 'EGIW02N'],
    ['IWS_MC_1', 'EGMC01N'], ['IWS_GC_2', 'EGGC01R'], ['IWS_YLC_1', 'EGYC01N'],
    ['EGDP01D', 'EGDP01D'],
    ['IWS_16A_1', 'EGIW03R'], ['SSS_2', 'EGIW04R'], ['IWS_3D_1', 'EGIW05R'], ['IWS_MC_2', 'EGCC01N'],
    ['IWS_GC_1', 'EGGC01R'], ['IWS_YLC_2', 'EGYC02R'], ['IWS_RGB_1', 'EGLC01R'], ['T_2', 'EGDS01N'],
    ['IWS_2RC_1', 'EGRC01R'], ['IWS_3RC_1', 'EGRC02R'], ['IWS_SC_AC_1', 'EGSM01R'], ['IWS_SC_DC_1', 'EGSM02N'],
    ['IWS_1D_0', 'EGIW06R'],
    ['EGRP01R', 'EGRP01R'], ['EGDC01R', 'EGDC01R'], ['EGED01M', 'EGED01M'], ['EGDS01D', 'EGDS01D'],
    ['IR_1', 'EGIR01N'], ['YLM_1', 'EGLM01N'], ['HUB_257', 'EGHB02M'], ['SS_2', 'EGIW07R'],
    ['IWS_2D_1', 'EGIW08N'], ['RPTR_1', 'EGRP01R'], ['IWS_3D_2', 'EGIW09R'], ['IWS_1D_1', 'EGIW10R'],
    ['EM_1', 'EGMM01N'], ['HUB_PRO_1', 'EGHB03M'],
    ['EM_2', 'EM_2'],
    ['IWS_TD_1', 'EGIW11N'], ['GLD_1', 'EGGS01N'],
    ['FM_1', 'FM_1'],
    ['DLR_1', 'EGLR01N'], ['T_3', 'EGDS02N'], ['DC_EP_1', 'EGDC01R'], ['IWS_SC_DC_2', 'EGSM03R'],
    ['DC_EP_1_ext_1', 'TPSC01R'], ['DC_EP_1_ext_2', 'TPSC02R'], ['DC_EP_1_ext_3', 'TPSC03R'],
    ['IWS_3D_3', 'EGIW12R'], ['TR_EP_1', 'EGTC01N']
  ]);

  nodeNameTypeMap = new Map([
    ['HUB', 'eGlu HUB'], ['P_1', 'eGlu Smart Plug 6A'], ['P16_1', 'eGlu Smart Plug 16A'], ['MS_1', 'eGlu Motion Sensor'],
    ['PA_1', 'eGlu Panic Alarm'], ['T_1', 'eGlu TAG'], ['SSS_1', 'eGlu In-wall Triple Switch'], ['SSD_1', 'eGlu In-wall Dual Switch + Dimmer'],
    ['IWS_MC_1', 'eGlu Motor Controller'], ['IWS_GC_2', 'eGlu Gate Controller'], ['IWS_YLC_1', 'eGlu Yale Lock Controller'],
    ['EGDP01D', 'eGlu Display Panel'],
    ['IWS_16A_1', 'eGlu In-wall 16A Switch'], ['SSS_2', 'eGlu In-wall Triple Switch'], ['IWS_3D_1', 'eGlu In-wall Triple Dimmer'], ['IWS_MC_2', 'eGlu Curtain Controller'],
    ['IWS_GC_1', 'eGlu Gate Controller'], ['IWS_YLC_2', 'eGlu Yale Lock Controller'], ['IWS_RGB_1', 'eGlu RGB LED Driver'], ['T_2', 'eGlu Door Sensor'],
    ['IWS_2RC_1', 'eGlu Dual Relay Controller'], ['IWS_3RC_1', 'eGlu Triple Relay Controller'], ['IWS_SC_AC_1', 'eGlu Sensor Monitor HV'], ['IWS_SC_DC_1', 'eGlu Sensor Monitor LV'],
    ['IWS_1D_0', 'eGlu High Power Dimmer'],
    ['EGRP01R', 'eGlu Repeater - Modified SMHV'], ['EGDC01R', 'eGlu DOS Controller'], ['EGED01M', 'eGlu Edge'], ['EGDS01D', 'eGlu Demo Suitcase'],
    ['IR_1', 'eGlu IR Controller'], ['YLM_1', 'eGlu Lock Module'], ['HUB_257', 'eGlu HUB-Lite'], ['SS_2', 'eGlu In-wall Dual Switch'],
    ['IWS_2D_1', 'eGlu In-wall Dual Dimmer'], ['RPTR_1', 'eGlu Repeater'], ['IWS_3D_2', 'eGlu In-wall Triple Dimmer - Gen2'], ['IWS_1D_1', 'eGlu High Power Dimmer - Gen2'],
    ['EM_1', 'eGlu Modbus Monitor'], ['HUB_PRO_1', 'eGlu HUB-Pro'],
    ['EM_2', 'Pulse Controller'],
    ['IWS_TD_1', 'eGlu In-wall Tunable Dimmer'], ['GLD_1', 'eGlu LPG Sensor'],
    ['FM_1', 'eGlu Flow Meter'],
    ['DLR_1', 'eGlu Lock Remote (Godrej)'], ['T_3', 'eGlu Door Sensor - Gen 2'], ['DC_EP_1', 'eGlu Dry Contact Switch Controller'], ['IWS_SC_DC_2', 'eGlu Multi Sensor Controller'],
    ['DC_EP_1_ext_1', 'Scene Controller - Touch'], ['DC_EP_1_ext_2', 'Scene Controller - Button - Black'], ['DC_EP_1_ext_3', 'Scene Controller - Button - Gray'],
    ['IWS_3D_3', 'eGlu In-wall Triple Dimmer - Gen3'], ['TR_EP_1', 'eGlu Touch Scene Controller']
  ]);

  private dashDataListener = new Subject<boolean>();
  private dashInfoDataListener = new Subject<boolean>();
  private dashSummaryDataListener = new Subject<boolean>(); //*
  private dashCustomSummaryDataListener = new Subject<boolean>();
  private dashOneYearHubDataListener = new Subject<boolean>();
  private dashFirmwareDataListener = new Subject<boolean>();
  private dashReleasedNodeTypeDataListener = new Subject<boolean>();
  private dashOldHubFirmwareDataListener = new Subject<boolean>();

  getdashDataListener() {
    return this.dashDataListener.asObservable();
  }

  getdashInfoDataListener() {
    return this.dashInfoDataListener.asObservable();
  }

  getSummaryDataListener() {
    return this.dashSummaryDataListener.asObservable();
  }

  getCustomRangeSummaryDataListener() {
    return this.dashCustomSummaryDataListener.asObservable();
  }

  getOneYearHubDataListener() {
    return this.dashOneYearHubDataListener.asObservable();
  }

  getFirmwareDataListener() {
    return this.dashFirmwareDataListener.asObservable();
  }
  getReleasedNodeTypeDataListener() {
    return this.dashReleasedNodeTypeDataListener.asObservable();
  }

  getOldHubFirmwareDataListener() {
    return this.dashOldHubFirmwareDataListener.asObservable();
  }

  fetchUsers(query: string): Observable<any> {
    console.log("fetching Users: " + query);
    this.params = query.split(",");
    return this.http.get<any>(`${this.env.apiUrl}/api/users?q=${this.params[0]}&i=${this.params[1]}&h=${this.params[2]}&p=${this.params[3]}&l=${this.params[4]}`).pipe(
      catchError(err => of([]))
    );
  }

  fetchData() {
    this.http.get(this.env.apiUrl + "/api/dashInfo")
      .subscribe(response => {
        console.log(response);
        this.dashInfo = response['props'];
        this.custInfo = response['docs'];
        this.statesData = response["statesData"];
        this.dashInfoDataListener.next(true);
      }, err => {
        console.log(err);
        this.dashInfoDataListener.next(false);
      })


    this.http.get(this.env.apiUrl + "/api/accountAnalytics")
      .subscribe(response => {
        console.log(response);
        // this.router.navigate(['/']);
        this.accountAnalytics = response;
        this.dashDataListener.next(true);
      }, err => {
        console.log(err);
        this.dashDataListener.next(false);
      })

  }

  fetchEngagementData(startDate, endDate) {
    this.http.get(this.env.apiUrl + `/api/engagementData?startDate=${startDate}&endDate=${endDate}`)
      .subscribe(response => {
        console.log(response);
        // this.router.navigate(['/']);
        // this.accountAnalytics = response;
        this.engagementData = response;
        this.dashDataListener.next(true);
      }, err => {
        console.log(err);
        this.dashDataListener.next(false);
      })
  }

  //function to fetch summary data from backend. This data is by default updated at every 6 hours in backend. This api call simply fetches the localized version of data.
  getSummary() {
    this.http.get(this.env.apiUrl + '/api/engagementData/getSummary')
      .pipe(
        timeout(10000),
        catchError(err => {
          this.dashSummaryDataListener.next(false)
          return of(false);
        })
      )
      .subscribe(response => {
        if (response) {
          this.summaryData = response;

          //sort node installation data array by number of installs per node type. (decreasing order)
          this.summaryData['data']['installationData']['nodeTypeCountForSevenDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          this.summaryData['data']['installationData']['nodeTypeCountForFifteenDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          this.summaryData['data']['installationData']['nodeTypeCountForThirtyDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          //check and fill outliers with count as 0
          this.setNodeTypeCount(this.summaryData['data']['installationData']['nodeTypeCountForSevenDays']);
          this.setNodeTypeCount(this.summaryData['data']['installationData']['nodeTypeCountForFifteenDays']);
          this.setNodeTypeCount(this.summaryData['data']['installationData']['nodeTypeCountForThirtyDays']);

          //sort online node data array by number of online nodes per node type. (decreasing order)
          this.summaryData['data']['onlineData']['onlineNodesInSevenDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          this.summaryData['data']['onlineData']['onlineNodesInFifteenDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          this.summaryData['data']['onlineData']['onlineNodesInThirtyDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          //check and fill outliers with count as 0
          this.setNodeTypeCount(this.summaryData['data']['onlineData']['onlineNodesInSevenDays']);
          this.setNodeTypeCount(this.summaryData['data']['onlineData']['onlineNodesInFifteenDays']);
          this.setNodeTypeCount(this.summaryData['data']['onlineData']['onlineNodesInThirtyDays']);
          this.dashSummaryDataListener.next(true);
        }
      }, err => {
        console.log(err);
        this.dashSummaryDataListener.next(false);
      })
  }

  //function to get eGlu summary for custom date range. Just like function getSummary...just this one makes on the spot db call in the api with provided start date and end date instead of fetching the regularly updated values from backend
  getCustomRangeSummary(startDate, endDate) {
    this.http.get(this.env.apiUrl + `/api/engagementData/getCustomSummary?startDate=${startDate}&endDate=${endDate}`)
      .pipe(
        timeout(10000),
        catchError(err => {
          this.dashCustomSummaryDataListener.next(false)
          return of(false);
        })
      )
      .subscribe(response => {
        if (response) {
          this.customSummaryData = response;
          this.customSummaryData['data']['installationData']['nodeTypeCountForSelectedDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          this.setNodeTypeCount(this.customSummaryData['data']['installationData']['nodeTypeCountForSelectedDays']);
          this.customSummaryData['data']['onlineData']['onlineNodesInSelectedDays'].sort(function (a, b) { return b.count > a.count ? 1 : -1 })
          this.setNodeTypeCount(this.customSummaryData['data']['onlineData']['onlineNodesInSelectedDays']);
          this.dashCustomSummaryDataListener.next(true);
        }
      }, err => {
        console.log(err);
        this.dashCustomSummaryDataListener.next(false);
      })
  }

  //this function takes array of nodes and replaces node type with node model
  setNodeTypeCount(arrayOfNodeTypeCount) {
    //if the array is empty that means no node data found for day range, so fill up with 0 for each node type
    if (!arrayOfNodeTypeCount.length) {
      for (let [key, value] of this.nodeTypeMap) {
        arrayOfNodeTypeCount.push({ '_id': value, 'type': key, 'name': this.nodeNameTypeMap.get(key), 'count': 0 });
      }
    } else {
      //else check and replace each type with respective model version
      for (var i = 0; i < arrayOfNodeTypeCount.length; i++) {
        const value = this.nodeTypeMap.get(arrayOfNodeTypeCount[i]['_id']);
        if (value) {
          arrayOfNodeTypeCount[i]['type'] = arrayOfNodeTypeCount[i]['_id'];
          arrayOfNodeTypeCount[i]['name'] = this.nodeNameTypeMap.get(arrayOfNodeTypeCount[i]['_id']);
          arrayOfNodeTypeCount[i]['_id'] = value;
        } else {
          arrayOfNodeTypeCount[i]['type'] = arrayOfNodeTypeCount[i]['_id'];
          arrayOfNodeTypeCount[i]['name'] = this.nodeNameTypeMap.get(arrayOfNodeTypeCount[i]['_id']);
          //found raw node type which is not in the node type map, so replace "_" with " " (if _ exist) and make words title case
          if (arrayOfNodeTypeCount[i]['_id'] !== null) {
            arrayOfNodeTypeCount[i]['_id'] =
              arrayOfNodeTypeCount[i]['_id'].includes("_") ?
                arrayOfNodeTypeCount[i]['_id'].toLowerCase()
                  .split("_")
                  .map(function (word) {
                    return (word.charAt(0).toUpperCase() + word.slice(1));
                  })
                  .join(" ")
                : arrayOfNodeTypeCount[i]['_id'].toLowerCase().charAt(0).toUpperCase() + arrayOfNodeTypeCount[i]['_id'].toLowerCase().slice(1);
          }
        }
      }
      //fill remaining types with count as 0
      for (let [key, value] of this.nodeTypeMap) {
        if (!arrayOfNodeTypeCount.some(function (el) { return el._id == value })) {
          arrayOfNodeTypeCount.push({ '_id': value, 'type': key, 'name': this.nodeNameTypeMap.get(key), 'count': 0 });
        }
      }
    }
  }

  //function to call api for downloading excel file of user data
  getExcelFile() {
    this.http.get(this.env.apiUrl + '/api/engagementData/downloadFile', { responseType: 'blob' })
      .subscribe(response => {
        const blob = new Blob([response]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const currentDate: Date = new Date();
        var seventhDay: Date = new Date();
        seventhDay = new Date(seventhDay.setDate(currentDate.getDate() - 7));
        const fileName = 'hub_installations_seven_days_' + seventhDay.getUTCFullYear() + '_' + this.monthsArray[seventhDay.getUTCMonth()] + '_' + seventhDay.getUTCDate() + '_' + currentDate.getUTCFullYear() + '_' + this.monthsArray[currentDate.getUTCMonth()] + '_' + currentDate.getUTCDate() + '.xlsx'
        link.download = fileName;
        link.click();
        link.remove();
      }, err => {
        console.log(err);
      })
  }

  getOneYearHubData() {
    this.http.get(this.env.apiUrl + '/api/engagementData/getOneYearHubData')
      .pipe(
        timeout(10000),
        catchError(err => {
          this.dashOneYearHubDataListener.next(false)
          return of(false);
        })
      )
      .subscribe(response => {
        if (response) {
          this.oneYearHubData = response['data'];
          //filling up graph data for last year hub installations---
          var xData = [];
          var yData = [];
          var graphData = {
            'hovertemplate': []
          };
          this.oneYearHubCount = 0;
          this.oneYearHubData.forEach((element, index) => {
            this.oneYearHubCount += element.count; //adding up total hub installations in last year
            if (element.dates != undefined) {
              var weekStart = moment(element.dates[0]).date() + ' ' + this.monthsArray[moment(element.dates[0]).month()] + ' ' + moment(element.dates[0]).year();
              var weekEnd = moment(element.dates[1]).date() + ' ' + this.monthsArray[moment(element.dates[1]).month()] + ' ' + moment(element.dates[1]).year();
              graphData['hovertemplate'].push('HUBS : ' + element.count + '<br>' + weekStart + " - " + weekEnd + '<extra></extra>');
              xData.push(moment(element.dates[0]).date() + " " + this.monthsArray[moment(element.dates[0]).month()] + " - " + moment(element.dates[1]).date() + " " + this.monthsArray[moment(element.dates[1]).month()]);
              yData.push(element.count);
            }
          });
          graphData['x'] = xData;
          graphData['y'] = yData;
          graphData['type'] = 'bar';

          this.graphDataForLastYear = graphData;

          //filling up graph data for last year hub installations---
          this.dashOneYearHubDataListener.next(true);
        }
      }, err => {
        console.log(err);
      })
  }

  fetchFirmwareData(hubFirmwareVersion, hubType, equality) {
    this.http.get(this.env.apiUrl + `/api/engagementData/getFirmwareData?firmwareVersion=${hubFirmwareVersion}&hubType=${hubType}&equality=${equality}`)
      .pipe(
        timeout(10000),
        catchError(err => {
          this.dashFirmwareDataListener.next(false);
          return of(false);
        })
      ).subscribe(response => {
        this.firmwareData = response['data'];
        this.dashFirmwareDataListener.next(true);
      }, err => {
        console.log(err);
        this.dashFirmwareDataListener.next(false);
      });
  }

  getDatabaseAnalyticsData(callback) {
    //make api call to get database analytics data
    this.http.get(this.env.apiUrl + `/api/engagementData/getDatabaseAnalyticsData`)
      .pipe(
        timeout(10000),
        catchError(err => {
          console.log(err);
          return of(false);
        })
      ).subscribe(response => {
        console.log(response);
        if (response) {
          callback(response['data']);
        }else {
          callback(undefined)
        }
      }, err => {
        console.log(err);
        callback(undefined)
      });
  }

  fetchReleasedNodeTypeData(releasedNodeType, startDate, endDate) {
    this.http.get(this.env.apiUrl + `/api/engagementData/getReleasedNodeTypeData?releasedNodeType=${releasedNodeType}&start=${startDate.toString()}&end=${endDate.toString()}`)
      .pipe(
        timeout(60000),
        catchError(err => {
          this.dashReleasedNodeTypeDataListener.next(false);
          return of(false);
        })
      ).subscribe(response => {
        this.releasedNodeTypeData = response;
        console.log(response);

        this.dashReleasedNodeTypeDataListener.next(true);
      }, err => {
        console.log(err);
        this.dashReleasedNodeTypeDataListener.next(false);
      });
  }

  fetchOldHubFirmwareData() {
    this.http.get(this.env.apiUrl + `/api/engagementData/getOldHubFirmwareData`)
      .pipe(
        timeout(10000),
        catchError(err => {
          console.log(err);
          this.dashOldHubFirmwareDataListener.next(false);
          return of(false);
        })
      ).subscribe(response => {
        this.oldHubFirmwareData = response['data'];
        this.dashOldHubFirmwareDataListener.next(true);
      }, err => {
        console.log(err);
        this.dashOldHubFirmwareDataListener.next(false);
      });
  }

}
